module.exports = {
  "edgeWidth": "3px",
  "arrowSize": "7px",
  "primaryColorShadow": "0px -@edge-width 0px 0px @background-primary",
  "cos45": "0.7071",
  "closeIconHeight": "22px"
};
